export default __webpack_public_path__ + "static/logoOnly-de626df08eff1a4c4d4b606382f63019.svg";